import { DETERMINAR_PAGINA_ATUAL_TOMADORES } from '../../types'

export default function determinarPaginaAtualTomadores (paginaAtual) {
    return {
      type: DETERMINAR_PAGINA_ATUAL_TOMADORES,
      payload: paginaAtual
    }
  }